import React from 'react';
import { Row, Col } from 'reactstrap';
import HeaderBar from '../Components/HeaderBar';
import OverviewPanel2 from './OverviewPanel2';
import ComparePanel from './ComparePanel';

class DimPanelGroup extends React.Component {
  constructor(props) {
    super();
    this.state = {
      showSettingsPanel: false,
    };
  }

  setSettingsPanelVisibility = (visible => {
    this.setState({showSettingsPanel: visible});
  }).bind(this)

  render() {
    let {sizeFactor} = this.props;
    if(!sizeFactor) sizeFactor = 1;
    return (
      <Row>
        <Col className="panel" xs={this.state.showSettingsPanel ? 8 : 6}>
          <HeaderBar text="Evaluation" />
          <OverviewPanel2
            base={this.props.base}
            filtered={this.props.filtered}
            filterTimeStamp={this.props.filterTimeStamp}
            onShowSettingPanel={this.setSettingsPanelVisibility}
            sizeFactor={sizeFactor}
          />
        </Col>
        <Col className="panel" xs={this.state.showSettingsPanel ? 4 : 6}>
          <HeaderBar text="Comparison" />
          <ComparePanel
            base={this.props.base}
            filtered={this.props.filtered}
            filterTimeStamp={this.props.filterTimeStamp}
            compact={this.state.showSettingsPanel}
            sizeFactor={sizeFactor}
          />
        </Col>
      </Row>
    )
  }
}

export default DimPanelGroup;
